<template>
  <Notification :show="state.notification.show" :type="state.notification.type" :message="state.notification.message" />
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex align-items-baseline justify-content-between">
              <h6 class="text-white text-capitalize ps-3">Tracking</h6>
              <div class="pe-3 text-end">
                <!-- Filters -->
                 <div class="d-flex align-items-baseline select-component">
                  <SelectComponent label="Select app name" :items="state.appName" @retrive-input-value="setAppNameSelected" />
                  <SelectComponent label="Select transactionId" :items="state.transactionIds" @retrive-input-value="setTransactionIdInMessages" />
                 </div>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
    
              <timeline-list class="h-100" title="Observability in realtime">

                <div v-for="(items, index) in state.socketMessages" :key="index">
                  <div v-for="(item, index2) in items.tracking" :key="index2">

                      <timeline-item :icon="{component: 'code', class: 'text-success'}"
                        :title="item.phaseName" 
                        :app-name="items.appName" 
                        :date-time="item.createdAt"
                        :transaction-id="items.transactionId" 
                      />

                  </div>
                  
                </div>
              </timeline-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>

import { onMounted, onUnmounted, reactive } from 'vue';
import TimelineList from "../examples/Cards/TimelineList.vue";
import TimelineItem from "../examples/Cards/TimelineItem.vue";
import { io } from 'socket.io-client';
import { getUserDataFromCookie } from '../utils/cookie'
import { httpPost } from '../services/axios'
import SelectComponent from '../components/SelectComponent.vue';
import Notification from '../components/Notification.vue'

const wesocketUrl = process.env.VUE_APP_API
const userData = getUserDataFromCookie() || undefined
const socket = io(`${wesocketUrl}`, {
  auth: {
    token: "", // It's need for public networks
    email: userData.email,
    userRoom: "GERAL"
  },
  withCredentials: true,
  transports: ["websocket"]
});

const state = reactive({
  socketMessages: [],
  appName: [],
  transactionIds: [],
  filter: {
    appName: null,
    transactionId: null
  },
  notification: {
        show: false,
        type: null,
        message: null
      }  
})

const getUserApp = async () => {

  let userApps = await httpPost('/getUserApp')
  if (userApps.status == 200) {
    state.appName = userApps.data.map(item => item.appName)
    if (userApps.data.length === 0) {
      state.notification = {
          show: true,
          type: 'warning',
          message: "<center>You don't have an app token yet! Create your first app <a href='./tables'>here</a></center>"
        }
    }
  } else {
    console.error(userApps)
  }
}

const getTracks = async (filter = {}) => {

  let tracks = await httpPost('/getTrack', filter)
  if (tracks.status == 200) {
    return tracks.data
  } else {
    console.error(tracks)
    return null
  }
}

const setAppNameSelected = async (appName) => {
  state.filter.transactionId = null
  let tracks = await getTracks({ appName: appName })
  console.log(tracks)
  if (!tracks.length) {
    state.transactionIds = []
    state.socketMessages = []
    state.filter.appName = appName
    return
  }
  state.transactionIds = tracks.map(item => item.transactionId)
  state.filter.appName = appName
  state.socketMessages = tracks.filter(item => item.appName == appName)
}

const setTransactionIdInMessages = async (transactionId) => {
  let tracks = await getTracks({ appName: state.filter.appName, transactionId: transactionId })
  if (!tracks) return
  state.filter.transactionId = transactionId
  state.socketMessages = tracks.filter(item => item.transactionId == transactionId)
}
const playSoundNotification = () => {
  const audio = new Audio(require('@/assets/audio/notification-smooth-modern-stereo-332449.mp3'));
  audio.play()
}
onMounted(async () => {
  socket.on('GERAL', (msg) => {
    // console.log('SOCKET ---> ', msg)
    try {
      if (
        (msg.appName == state.filter.appName && msg.transactionId == state.filter.transactionId)
         ||
        (msg.appName == state.filter.appName && !state.filter.transactionId)
      ) {
        state.socketMessages.unshift(msg)
        playSoundNotification()
        return
      }
      
    } catch (e) {
      console.error(e)
    }
  });
  getUserApp()

});

onUnmounted(() => {
  socket.off('message');
});
</script>

<style scoped>
.select-component {
  width: 17em;
  height: .5em;
  color: #FFF;
}
pre {
  max-height: 10em;
}
</style>